import { createSelector } from 'reselect'

const getLtiData = state => state.lti

const ltiDataSelector = createSelector(
	[ getLtiData ],
	ltiData => ({
		ltiUid: ltiData.ltiUid || '',
		ltiToken: ltiData.ltiToken || '',
	})
)

export default ltiDataSelector
